import React from 'react';
import PropTypes from 'prop-types';

const typeaheadEntryClass = 'typeahead-result-wrapper';
const searchTermClass = 'search-term';

const TypeaheadEntry = ({ href, name, searchTerm }) => {

    return <div className={typeaheadEntryClass}>
        <a href={href}>
            {name.split(" ").map(word => {
                return word.toLowerCase() === searchTerm.toLowerCase() ? <span className={searchTermClass}>{searchTerm} </span> : <>{word} </>;
            })}
        </a>
    </div>
}

TypeaheadEntry.propTypes = {
    href: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    imageUrl: PropTypes.string
};


const CategoryTypeaheadEntry = ({ href, name, searchTerm }) => {

    return <div className={typeaheadEntryClass}>
        <a href={href}>
            <span className={searchTermClass}>{searchTerm}</span> in {name}
        </a>
    </div>
}

TypeaheadEntry.propTypes = {
    href: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string
};

export { TypeaheadEntry, CategoryTypeaheadEntry };